module.exports = __webpack_public_path__ + "static/fonts/RaisonnePro-Regular.f18a60a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/RaisonnePro-Regular.woff
// module id = TqbL
// module chunks = 18